<template>
  <button
    :type="type || 'button'"
    class="ec-btn"
    :class="[
      'ec-btn--' + (variant || 'primary'),
      size ? 'ec-btn--' + size : '',
    ]"
    :disabled="disabled || loading"
    :title="title"
    @click="$emit('click', $event)"
  >
    <span v-if="loading" class="ec-spinner__circle ec-spinner__circle--sm" role="status" />
    <i v-else-if="icon" :class="'bi bi-' + icon" />
    <slot />
  </button>
</template>

<script>
export default {
  name: 'EcButton',
  props: {
    variant: { type: String, default: 'primary' },
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    type: { type: String, default: 'button' },
  },
}
</script>
